import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useNavigate } from "react-router-dom";

//Redux
import { useSelector } from "react-redux"; //useDispatch
//API
import ItemService from "../../../../services/supplier_appCommonService";
//Components
import Layout from "../../../../Layout/Layout";
import { InputField } from "../../../../Components/formElements/InputField";
import DataTable from "react-data-table-component";
import SourcingCommonFilter from "../../../../Components/Filter/Sourcing/SourcingCommonFilter";
import Constants from "../../../../common/SupplierConstants";
import CommonItemLevelDatatableModal from "../../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";
import { formatDate } from "../../../../common/Validations";
import ApproveRemarksModal from "../../../../Components/Modal/supplier_app/ApproveRemarksModal";
import SuccessModal from "../../../../Components/Modal/supplier_app/SuccessModal";
import toast from "react-hot-toast";
import FileViewerModal from "../../../../Components/FileViewer/FileViewerModal";
import CustomerConstants from "../../../../common/CustomerConstants";
import QualityCheckModalDetail from "./QualityCheckModalDetail";
import { Modal } from "react-bootstrap";

const QualityCheckDetailsV5 = () => {
  const navigate = useNavigate();
  localStorage.setItem("menu", "Purchasing");
  localStorage.setItem("submenu", "");

  // eslint-disable-next-line
  let grnNumber = useSelector(
    (state) => state?.purchasing?.goods_received_note?.grnNumber,
  ); // User Details from Store
  let workflow = useSelector(
    (state) => state?.purchasing?.purchase_order?.workflowPO,
  ); // workflowPO from Store
  let qualityCHeckNr = useSelector(
    (state) => state?.customer?.qualityCheck?.documentNumber,
  );
  // eslint-disable-next-line
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [getHeaderData, setHeaderData] = useState({
    grnStatusHeader: "",
  });
  // state for acordion
  const [isCardVisible1, setCardVisible1] = useState(true);
  const [isCardVisible2, setCardVisible2] = useState(true);
  const [isCardVisible3, setCardVisible3] = useState(true);

  const [getItemHeaderTextData, setItemHeaderTextData] = useState("");
  const [getItemHeaderTextColumns, setItemHeaderTextColumns] = useState("");
  const [getItemHeaderTextModalTitle, setItemHeaderTextModalTitle] =
    useState(false);
  const [getItemTextModalShow, setItemTextModalShow] = useState(false);
  const [formInputs, setFormInputs] = useState({
    email: "",
    firstName: "",
    lastName: "",
    contactNumber: "",
    companyName: "",
    _id: "",
  });
  // View attachment files
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);
  const toggleCardVisibility1 = () => {
    setCardVisible1(!isCardVisible1);
  };
  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };
  const toggleCardVisibility3 = () => {
    setCardVisible3(!isCardVisible3);
  };

  // Workflow
  const [modalShow, setModalShow] = useState(false);
  const [getAction, setAction] = useState("");

  /* success modal */
  const successModalData = {
    title: "Message",
    successMsg: "",
  };
  const [getShowSuccessModal, setShowSuccessModal] = useState(false);
  const [getsucceModalData, setsucceModalData] = useState(successModalData);
  const [getNextNavigate, setNextNavigate] = useState("");
  const onSuccessmodel = () => {
    setShowSuccessModal(true);
  };
  const hideSuccessModal = () => {
    setShowSuccessModal(false);
  };

  const itemHeaderColInfo = [
    {
      name: "Code",
      cell: (row) => <span>{row.documentId} </span>,
      width: "200px",
    },
    {
      name: "Text",
      cell: (row) => <span>{row.documentText} </span>,
      width: "250px",
    },
  ];

  // OnClick on ITEM Text Data
  // eslint-disable-next-line
  const itemTextShowModal = (itemTextData) => {
    setItemHeaderTextData(itemTextData);
    setItemHeaderTextColumns(itemHeaderColInfo);
    setItemHeaderTextModalTitle("Item Text Details");
    setItemTextModalShow(true);
  };
  const itemTextHideModal = () => {
    setItemTextModalShow(false);
  };
  const [showQCModal, setShowQCModal] = useState(false);
  const [qcType, setQcType] = useState("");
  const [selectedRow, setSelectedRow] = useState(null);
  // eslint-disable-next-line
  const [qcData, setQcData] = useState({});

  const [qualityCheckItems, setQualityCheckItems] = useState([]);

  const sortedQualityCheckItems = React.useMemo(() => {
    return [...qualityCheckItems].sort(
      (a, b) => Number(a.grnItemNr) - Number(b.grnItemNr),
    );
  }, [qualityCheckItems]);

  // eslint-disable-next-line
  const qualityChecks = qualityCheckItems.map((qc) => ({
    grnItemNr: qc.grnItemNr,
    materialCode: qc.materialCode,
    materialDescription: qc.materialDescription,
    grnQuantity: qc.grnQuantity,
    qcType: qc.qcType,
    buyBackItem: qc.buyBackItem,

    packagingCondition: qc.packagingCondition || "",
    physicalDamage: qc.physicalDamage || "",
    quantityVerified: qc.quantityVerified || "",
    inspectionRemarks: qc.inspectionRemarks || "",

    modelMatch: qc.modelMatch || "",
    brandMatch: qc.brandMatch || "",
    sizeGradeMatch: qc.sizeGradeMatch || "",
    technicalParamsOk: qc.technicalParamsOk || "",
  }));

  const getGodownCode = (value) => {
    if (value === "Rent") return "RE";
    if (value === "Sale") return "SL";
    return "NA";
  };
  const calculateMonthlyRoiAmount = (unitPrice, roiMonths) => {
    if (!unitPrice || !roiMonths) return 0;
    return Number((unitPrice / roiMonths).toFixed(2));
  };

  const handleCreateBarcode = async (row) => {
    try {
      const godownCode = getGodownCode(row.storageLocation);
      const roiCodeMonths = 36;
      const unitPrice = Number(row.unitPrice) || 0;

      const itemsExtraFields = {
        buyBack: row.buyBackItem,
        materialAttachments: row.materialAttachments,
        materialImage: row.materialImage,
        materialCode: row.materialCode,
        materialDescription: row.materialDescription,
        materialGroup: row.materialGroup,
        average: row.average,
        quntity: row.quntity,
        pieceMeasure: row.pieceMeasure,
        unit: row.unit,
        unitWeight: row.unitWeight,
        unitPrice: row.unitPrice,
        unitWeightModifier: row.unitWeightModifier,
        unitPriceModifier: row.unitPriceModifier,
        surfacePaintArea: row.surfacePaintArea,
        remarks: row.remarks,
        weightPice: row.weightPice,
        weightTotal: row.weightTotal,
        bookPrice: row.bookPrice,
        bookTotalPrice: row.bookTotalPrice,
        topSelling: row.topSelling,
        companyCode: row.companyCode,
        companyCodeCode: row.companyCodeCode,
        companyCodeDesc: row.companyCodeDesc,
        materialSubCategory: row.materialSubCategory,
        hsnCode: row.hsnCode,
        location: row.location,
        purchaseQuantity: row.purchaseQuantity,
        unitCode: row.unitCode,
        unitDesc: row.unitDesc,
        targetCategory: row.targetCategory,
        criticalProduct: row.criticalProduct,
        brand: row.brand,
        storageLocation: row.storageLocation,
        storageLocationCode: row.storageLocationCode,
        storageLocationDesc: row.storageLocationDesc,
        discarded: row.discarded,
        warranty: row.warranty,
        mrPrice: row.mrPrice,
        taxCode: row.taxCode,
        cog: row.cog,
        salePrice: row.salePrice,
        rentPerDayPrice: row.rentPerDayPrice,
        rent7DaysPrice: row.rent7DaysPrice,
        rent15DaysPrice: row.rent15DaysPrice,
        rent30DaysPrice: row.rent30DaysPrice,
        securityAmt: row.securityAmt,
        lockInPeriod: row.lockInPeriod,
        activeInactive: row.activeInactive,
        orderPriceUnit: row.orderPriceUnit,
        orderUnitOfMeasure: row.orderUnitOfMeasure,
        uOM: row.uOM,
        hospital: row.hospital,
        accessories:row?.accessories,
        accessoriesCode:row?.accessoriesCode,

        // buyBackItem:row.buyBackItem,
      };

      const rentExtraFields =
        godownCode === "RE"
          ? {
              assetActiveInactive: true,
              roiCodeMonths,
              monthlyRoiAmount: calculateMonthlyRoiAmount(
                unitPrice,
                roiCodeMonths,
              ),
              materialStatus: "StockIn",
            }
          : {};

      const saleExtraFields =
        godownCode === "SL"
          ? {
              assetActiveInactive: true,
              materialStatus: "StockIn",
            }
          : {};

      // Payload
      const payload = {
        data: {
          CreatedTime: 0,
          assambledBrcode: "NULL",
          barcodeStatus: 0,
          chno: "NULL",
          companyCodeDesc: row.companyCodeDesc || null,
          createdOn: new Date().toISOString().split("T")[0],
          disassambledBrcode: "NULL",
          dissambleto: "NULL",
          entryType: null,
          erfNr: null,
          godown: row.storageLocation,
          godownCode: godownCode,
          ...rentExtraFields,
          ...saleExtraFields,
          ...itemsExtraFields,
          godown1: null,
          gstCode: null,
          iphslrPrice: row.iphslrPrice,
          mrPrice: row.mrPrice,
          pcdlrPrice: row.pcdlrPrice,
          unitPrice: row.unitPrice,
          storageLocation: row.storageLocation,
          materialCode: row.materialCode,
          materialDescription: row.materialDescription,
          materialItemNr: row.materialItemNr,
          purchaseQuantity: Number(row.grnQuantity),
          buyBack: row.buyBackItem,
          purchasingCategorytype: row.purchasingCategorytype,
          purchasingDocumentNr: row.purchasingDocumentNr,
          purchasingtype: "Purchase",
          rcvby: getHeaderData?.createdByName || "SYSTEM",
          grnItemNr: row.grnItemNr,
          status: "NULL",
          stockadj: "NULL",
          supplierLotno: "NULL",
          qualityCheckNr: formInputs.qualityCheckNr,
          qualityCheckDetails: row.qualityCheckDetails || [],
          mfgBy: row?.mfgBy || "",
          mktBy: row?.mktBy || "",
        },
      };

      const res = await ItemService.addMaterialBarcodeItem(payload);

      if (res?.status === 200) {
        toast.success("Barcode created successfully");
        await loadInitialPageData();
      } else {
        toast.error(res?.message || "Barcode creation failed");
      }
    } catch (error) {
      console.error("Barcode Error", error);
      toast.error("Something went wrong");
    }
  };

  const handleQCCheck = (type, row) => {
    // Find existing QC data
    const existingQC = qualityCheckItems.find(
      (item) => item.grnItemNr === row.grnItemNr && item.qcType === type,
    );

    setQcType(type);
    setSelectedRow({
      ...row,
      ...(existingQC || {}), //  Merge existing data
    });
    setShowQCModal(true);
  };

  const handleViewQC = (type, row) => {
    const savedQC = qualityCheckItems.find(
      (item) => item.grnItemNr === row.grnItemNr && item.qcType === type,
    );

    setQcType(type);
    setSelectedRow({
      ...row,
      ...(savedQC || {}), // ✅ Just merge, even if empty
    });
    setShowQCModal(true);
  };

  const handleCheckboxClick = (type, row, e) => {
    e.preventDefault();

    const isChecked =
      type === "PHYSICAL" ? row.hasPhysicalQC : row.hasSpecificationQC;

    if (isChecked) {
      // Already checked - view existing data
      handleViewQC(type, row);
    } else {
      handleQCCheck(type, row);
    }
  };

  const [showBarcodeModal, setShowBarcodeModal] = useState(false);
  const [selectedBarcodeRow, setSelectedBarcodeRow] = useState(null);

  const handleViewBarcode = (row) => {
    setSelectedBarcodeRow(row);
    setShowBarcodeModal(true);
  };

  const handleCloseBarcodeModal = () => {
    setShowBarcodeModal(false);
    setSelectedBarcodeRow(null);
  };

  const columns = [
    {
      name: "GRN Item Nr",
      selector: (row) => row.grnItemNr,
      sortable: true,
      width: "130px",
    },
    {
      name: "PO Item",
      selector: (row) => row.purchasingDocumentItemNr,
      width: "100px",
    },
    {
      name: "PO Number",
      selector: (row) => row.purchasingDocumentNr,
      width: "120px",
    },

    ...(getHeaderData?.purchaseTypeCode?.trim() === "SER"
      ? [
          {
            name: "Schedule Nr",
            selector: (row) => row.scheduleNr,
            width: "150px",
          },
        ]
      : []),

    {
      name: "Material",
      cell: (row) => (
        <div>
          <div>
            <strong>{row.materialCode}</strong>
          </div>
          <div className="text-muted">{row.materialDescription}</div>
        </div>
      ),
      width: "200px",
    },
    {
      name: "UOM / PO Qty",
      cell: (row) => (
        <div className="d-flex flex-column">
          <span>
            {row.orderUnitOfMeasure}
            <span className="fw fw-bold ms-2">{row.purchaseQuantity}</span>
          </span>
        </div>
      ),
      width: "160px",
    },
    {
      name: "GRN Qty",
      selector: (row) => row.grnQuantity,
      width: "120px",
    },
    {
      name: "Quality Check",
      width: "240px",
      cell: (row) => (
        <div className="d-flex gap-3 ms-1">
          {/* PHYSICAL */}
          <div>
            <input
              type="checkbox"
              checked={row.hasPhysicalQC || false}
              disabled={editMode}
              readOnly
              onClick={(e) => {
                if (!editMode) {
                  handleCheckboxClick("PHYSICAL", row, e);
                }
              }}
            />
            <label
              className={`ms-1 fw-bold ${
                editMode ? "text-muted" : "cursor-pointer"
              }`}
              style={{ cursor: editMode ? "default" : "pointer" }}
              onClick={() => {
                if (!editMode) {
                  if (row.hasPhysicalQC) {
                    handleViewQC("PHYSICAL", row);
                  } else {
                    handleQCCheck("PHYSICAL", row);
                  }
                }
              }}
            >
              Physical
            </label>
          </div>

          {/* SPECIFICATION */}
          <div>
            <input
              type="checkbox"
              checked={row.hasSpecificationQC || false}
              disabled={editMode}
              readOnly
              onClick={(e) => {
                if (!editMode) {
                  handleCheckboxClick("SPECIFICATION", row, e);
                }
              }}
            />
            <label
              className={`ms-1 fw-bold ${
                editMode ? "text-muted" : "cursor-pointer"
              }`}
              style={{ cursor: editMode ? "default" : "pointer" }}
              onClick={() => {
                if (!editMode) {
                  if (row.hasSpecificationQC) {
                    handleViewQC("SPECIFICATION", row);
                  } else {
                    handleQCCheck("SPECIFICATION", row);
                  }
                }
              }}
            >
              Specification
            </label>
          </div>
        </div>
      ),
    },
    //     {
    //   name: "Barcode",
    //   width: "150px",
    //   cell: (row) => (
    //     <button
    //       className="btn btn-sm btn-primary"
    //       onClick={() => handleCreateBarcode(row)}
    //     >
    //       Create Barcode
    //     </button>
    //   ),
    // },
    // {
    //   name: "Barcode",
    //   width: "160px",
    //   cell: (row) => {
    //     const hasBarcode =
    //       row.barcodeInfo && Array.isArray(row.barcodeInfo) && row.barcodeInfo.length > 0;

    //     return hasBarcode ? (
    //       <button
    //         className="btn btn-sm btn-success"
    //         onClick={() => handleViewBarcode(row)}
    //       >
    //         View Barcode
    //       </button>
    //     ) : (
    //       <button
    //         className="btn btn-sm btn-primary"
    //         onClick={() => handleCreateBarcode(row)}
    //       >
    //         Create Barcode
    //       </button>
    //     );
    //   },
    // },

    {
      name: "Barcode",
      width: "160px",
      cell: (row) => {
        const hasBarcode =
          row.barcodeInfo &&
          Array.isArray(row.barcodeInfo) &&
          row.barcodeInfo.length > 0;

        const grnQty = row.grnQuantity;

        // If GRN Qty is empty, 0, or null → don't show button
        if (!grnQty || grnQty === 0) {
          return null;
        }

        return hasBarcode ? (
          <button
            className="btn btn-sm btn-success"
            onClick={() => handleViewBarcode(row)}
          >
            View Barcode
          </button>
        ) : (
          <button
            className="btn btn-sm btn-primary"
            onClick={() => handleCreateBarcode(row)}
          >
            Create Barcode
          </button>
        );
      },
    },

    {
      name: "Balance Qty",
      selector: (row) => row.grnBalancePurchaseQuantity,
      width: "150px",
    },
    {
      name: "Storage Location",
      selector: (row) => row.storagePlace,
      width: "180px",
    },
  ];

  // const mapItemsWithQC = (items = [], qualityChecks = []) => {
  //   return items.map((rawItem) => {
  //     const item = rawItem.data ?? rawItem;

  //     const qcList = qualityChecks.filter(
  //       (qc) => Number(qc.grnItemNr) === Number(item.grnItemNr)
  //     );

  //     const physicalQC = qcList.find(qc => qc.qcType === "PHYSICAL");
  //     const specificationQC = qcList.find(qc => qc.qcType === "SPECIFICATION");

  //     const hasPhysicalQC =
  //       !!physicalQC &&
  //       (
  //         physicalQC.packagingCondition ||
  //         physicalQC.physicalDamage ||
  //         physicalQC.quantityVerified ||
  //         physicalQC.inspectionRemarks
  //       );

  //     const hasSpecificationQC =
  //       !!specificationQC &&
  //       (
  //         specificationQC.modelMatch ||
  //         specificationQC.brandMatch ||
  //         specificationQC.sizeGradeMatch ||
  //         specificationQC.technicalParamsOk
  //       );

  //     return {
  //       // ---------- FULL ITEM
  //       ...item,

  //       // ---------- NORMALIZE (barcode safe)
  //       mrPrice: Number(item.mrPrice) || 0,
  //       iphslrPrice: Number(item.iphslrPrice) || 0,
  //       pcdlrPrice: Number(item.pcdlrPrice) || 0,
  //       orderPriceUnit: Number(item.orderPriceUnit) || 0,
  //       purchaseQuantity: Number(item.purchaseQuantity) || 0,
  //       // buyBackItem:item.buyBackItem,

  //       // ---------- QC FLAGS
  //       hasPhysicalQC,
  //       hasSpecificationQC,

  //       // ---------- UI FLAT FIELDS
  //       packagingCondition: physicalQC?.packagingCondition || "",
  //       physicalDamage: physicalQC?.physicalDamage || "",
  //       quantityVerified: physicalQC?.quantityVerified || "",
  //       inspectionRemarks: physicalQC?.inspectionRemarks || "",
  //       // buyBackItem: physicalQC?.buyBackItem || "",

  //       modelMatch: specificationQC?.modelMatch || "",
  //       brandMatch: specificationQC?.brandMatch || "",
  //       sizeGradeMatch: specificationQC?.sizeGradeMatch || "",
  //       technicalParamsOk: specificationQC?.technicalParamsOk || "",
  //       // buyBackItem: specificationQC?.buyBackItem || "",

  //       // ---------- QC OBJECTS
  //       physical: hasPhysicalQC ? { ...physicalQC } : null,
  //       specification: hasSpecificationQC ? { ...specificationQC } : null,

  //       // ----------  FULL QC ARRAY (NEW)
  //       qualityCheckDetails: qcList.length ? qcList : []
  //     };
  //   });
  // };

  const mapItemsWithQC = (items = [], qualityChecks = []) => {
    return items.map((rawItem) => {
      const item = rawItem.data ?? rawItem;

      const qcList = qualityChecks.filter(
        (qc) => Number(qc.grnItemNr) === Number(item.grnItemNr),
      );

      const physicalQC = qcList.find((qc) => qc.qcType === "PHYSICAL");
      const specificationQC = qcList.find(
        (qc) => qc.qcType === "SPECIFICATION",
      );

      const hasPhysicalQC =
        !!physicalQC &&
        (physicalQC.packagingCondition ||
          physicalQC.physicalDamage ||
          physicalQC.quantityVerified ||
          physicalQC.inspectionRemarks);

      const hasSpecificationQC =
        !!specificationQC &&
        (specificationQC.modelMatch ||
          specificationQC.brandMatch ||
          specificationQC.sizeGradeMatch ||
          specificationQC.technicalParamsOk);

      return {
        // ---------- FULL ITEM
        ...item,

        // ---------- NORMALIZE (barcode safe)
        mrPrice: Number(item.mrPrice) || 0,
        iphslrPrice: Number(item.iphslrPrice) || 0,
        pcdlrPrice: Number(item.pcdlrPrice) || 0,
        orderPriceUnit: Number(item.orderPriceUnit) || 0,
        purchaseQuantity: Number(item.purchaseQuantity) || 0,

        // ---------- QC FLAGS
        hasPhysicalQC,
        hasSpecificationQC,

        // ---------- HEADER BUYBACK (ensure boolean)
        buyBackItem: Boolean(item.buyBackItem),

        // ---------- UI FLAT FIELDS (PHYSICAL)
        packagingCondition: physicalQC?.packagingCondition || "",
        physicalDamage: physicalQC?.physicalDamage || "",
        quantityVerified: physicalQC?.quantityVerified || "",
        inspectionRemarks: physicalQC?.inspectionRemarks || "",

        // ---------- UI FLAT FIELDS (SPECIFICATION)
        modelMatch: specificationQC?.modelMatch || "",
        brandMatch: specificationQC?.brandMatch || "",
        sizeGradeMatch: specificationQC?.sizeGradeMatch || "",
        technicalParamsOk: specificationQC?.technicalParamsOk || "",

        // ---------- QC OBJECTS
        physical: hasPhysicalQC
          ? {
              ...physicalQC,
              buyBackItem: Boolean(item.buyBackItem),
            }
          : null,

        specification: hasSpecificationQC
          ? {
              ...specificationQC,
              buyBackItem: Boolean(item.buyBackItem),
            }
          : null,

        // ---------- FULL QC ARRAY (inject header buyBackItem)
        qualityCheckDetails: qcList.length
          ? qcList.map((qc) => ({
              ...qc,
              buyBackItem: Boolean(item.buyBackItem),
            }))
          : [],
      };
    });
  };

  const loadInitialPageData = async () => {
    setLoading(true);

    if (!qualityCHeckNr) return;

    const toastId = toast.loading("Loading...", {
      position: "top-right",
    });

    try {
      const payload = {
        queryName: "getQualityCheckDetail",
        documentNumber: qualityCHeckNr,
        page: 1,
        per_page: 10,
        timeZone: "Asia/Calcutta",
      };

      const response = await ItemService.generateQuery(payload);

      if (response?.status === 200) {
        const qcData = response?.data?.[0];

        if (!qcData) {
          toast.error("Quality Check not found");
          return;
        }

        // ---------- FORM DATA
        setFormInputs({
          ...qcData,
          documentNumber: qcData.documentNumber,
          qualityCheckNr: qcData.qualityCheckNr,
          qualityCheckStatus: qcData.qualityCheckStatus,
          createdBy: qcData.createdBy,
          createdByName: qcData.createdByName,
        });

        // ---------- HEADER DATA
        setHeaderData({
          vendorCode: qcData.vendorCode,
          vendorName: qcData.vendorName,
          purchasingDocumentNr: qcData.purchasingDocumentNr,
          purchasingDocumentDate: qcData.purchasingDocumentDate,
          purchasingDocumentValue: qcData.purchasingDocumentValue,
          currencyCode: qcData.currencyCode,
          paymentTerms: qcData.paymentTerms,
          grnNr: qcData.grnNr,
          mrPrice: qcData.mrPrice,
        });

        // ---------- LINE ITEMS + QC
        const mappedData = mapItemsWithQC(
          qcData.items || [],
          qcData.qualityChecks || [],
        );
        setQualityCheckItems(mappedData);
      } else {
        toast.error(response?.message || "Failed to load data");
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong");
    } finally {
      toast.dismiss(toastId);
      setLoading(false);
    }
  };

  useEffect(() => {
    loadInitialPageData(); // fetch page 1 of users

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [qualityCHeckNr]);

  const buildQualityChecksPayload = (items = []) => {
    const qualityChecks = [];

    items.forEach((item) => {
      // PHYSICAL QC - only if checkbox is checked AND has data
      if (
        item.hasPhysicalQC &&
        (item.packagingCondition ||
          item.physicalDamage ||
          item.quantityVerified ||
          item.inspectionRemarks)
      ) {
        qualityChecks.push({
          grnItemNr: item.grnItemNr,
          qcType: "PHYSICAL",
          packagingCondition: item.packagingCondition || "",
          physicalDamage: item.physicalDamage || "",
          quantityVerified: item.quantityVerified || "",
          inspectionRemarks: item.inspectionRemarks || "",
        });
      }

      // SPECIFICATION QC - only if checkbox is checked AND has data
      if (
        item.hasSpecificationQC &&
        (item.modelMatch ||
          item.brandMatch ||
          item.sizeGradeMatch ||
          item.technicalParamsOk)
      ) {
        qualityChecks.push({
          grnItemNr: item.grnItemNr,
          qcType: "SPECIFICATION",
          modelMatch: item.modelMatch || "",
          brandMatch: item.brandMatch || "",
          sizeGradeMatch: item.sizeGradeMatch || "",
          technicalParamsOk: item.technicalParamsOk || "",
        });
      }
    });

    return qualityChecks;
  };

  const handleUpdate = async () => {
    // Check if any QC is completed
    const hasAnyQC = qualityCheckItems.some(
      (row) => row.hasPhysicalQC || row.hasSpecificationQC,
    );

    if (!hasAnyQC) {
      toast.error(
        "Please complete at least one Quality Check before updating.",
        {
          position: "top-right",
        },
      );
      return;
    }

    // Verify qualityCheckItems has actual QC data
    const qcPayload = buildQualityChecksPayload(qualityCheckItems);

    if (qcPayload.length === 0) {
      toast.error(
        "No Quality Check data found. Please add Quality Check details.",
        {
          position: "top-right",
        },
      );
      return;
    }

    try {
      const updateObj = {
        documentNumber: formInputs.qualityCheckNr,
        qualityCheckNr: formInputs.qualityCheckNr,
        grnNr: formInputs.grnNr,
        qualityChecks: qcPayload,
      };

      const response = await ItemService.updateQualityCheck(updateObj);

      if (response?.status === 200 || response?.data?.status === "SUCCESS") {
        toast.success("Quality Check Updated Successfully", {
          position: "top-right",
        });
        setEditMode(true);
        navigate(CustomerConstants.CUSTOMER_V5_QUALITY_CHECK_LIST_MR);
      } else {
        toast.error(
          response?.message || "Update failed. Please check your data.",
          {
            position: "top-right",
          },
        );
      }
    } catch (error) {
      console.error("Update Error:", error);
      toast.error("Something went wrong during the update.", {
        position: "top-right",
      });
    }
  };

  // eslint-disable-next-line
  const [tableData, setTableData] = useState([]);

  const handleSaveQualityCheck = (qcPayload) => {
    setQualityCheckItems((prev) =>
      prev.map((item) => {
        if (item.grnItemNr !== qcPayload.grnItemNr) {
          return item;
        }

        return {
          ...item,

          //  merge QC form values
          ...qcPayload,

          //  update flags correctly
          hasPhysicalQC:
            qcPayload.qcType === "PHYSICAL" ? true : item.hasPhysicalQC,

          hasSpecificationQC:
            qcPayload.qcType === "SPECIFICATION"
              ? true
              : item.hasSpecificationQC,
        };
      }),
    );
  };

  const showApproveModal = async (name) => {
    setModalShow(true);
    setAction(name);
  };

  const workflowApproveReject = async (remarks) => {
    let obj = {};
    let bodyObj = workflow?.workflow_record?.workflowActionAPI?.Body;

    obj._id = workflow?.workflow_record?._id;
    obj.businessComponentId = workflow?.workflow_record?.businessComponentId;
    obj.eventId = workflow?.workflow_record?.eventId;
    obj.businessComponentInstanceId =
      workflow?.workflow_record?.businessComponentInstanceId;
    obj.stepId = workflow?.workflow_record?.stepId;
    obj.action = getAction;
    obj.remark = remarks;
    obj.editContextData = workflow?.workflow_record?.editContextData;
    obj.editForm = workflow?.workflow_record?.editForm;
    obj.data = {};
    let newObj = { ...bodyObj, ...obj };

    //Approve
    await ItemService.workflowApproveReject(newObj).then((item) => {
      if (item?.status === 200) {
        successModalData.successMsg =
          getAction === "Approve"
            ? "Approved Successfully !!"
            : "Rejected Successfully !!";
        setsucceModalData(successModalData);
        setNextNavigate(Constants.INBOX);
        onSuccessmodel();
      } else {
        console.log(">> Error: Loading workflowApproveReject");
      }
    });
  };

  const handleValueChange = (remarks) => {
    workflowApproveReject(remarks);
  };

  const hideModal = () => {
    setModalShow(false);
  };

  // View attachment files
  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };
  const [editMode, setEditMode] = useState(true);
  const TrasnportUpdate = () => {
    setEditMode(false);
  };
  const cancelUpdate = () => {
    setEditMode(true);
  };

  const onInputChange = ({ target: { name, value } }) => {
    setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));
  };

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <h2 className="mainTitle">
              Quality Details :
              <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
                {formInputs.qualityCheckNr || "--"}
              </span>
              {/* <span className="bg-table-status bg-table-danger-status headerStatusDetailedPage">
                {formInputs.grnStatusHeader || "--"}
              </span> */}
              <span
                className={`bg-table-status ${
                  formInputs.grnStatusHeader === "GRN Created"
                    ? "bg-table-documentNumber-status"
                    : "bg-table-danger-status"
                } headerStatusDetailedPage`}
              >
                {formInputs.grnStatusHeader || "--"}
              </span>
              <span>
                {getHeaderData?.grnStatusHeader === "GRN Created" ? (
                  <span className="bg-table-status bg-table-new-status headerStatusDetailedPage">
                    {getHeaderData?.grnStatusHeader}
                  </span>
                ) : getHeaderData?.grnStatusHeader ===
                  "Pending for Approval" ? (
                  <span className="bg-table-status bg-table-progress-status headerStatusDetailedPage">
                    {getHeaderData?.grnStatusHeader}
                  </span>
                ) : getHeaderData?.grnStatusHeader === "GRN Cancelled" ? (
                  <span className="bg-table-status bg-table-danger-status headerStatusDetailedPage">
                    {getHeaderData?.grnStatusHeader}
                  </span>
                ) : getHeaderData?.grnStatusHeader === "Invoice Cancelled" ? (
                  <span className="bg-table-status bg-table-danger-status headerStatusDetailedPage">
                    {getHeaderData?.grnStatusHeader}
                  </span>
                ) : getHeaderData?.grnStatusHeader === "GRN Rejected" ? (
                  <span className="bg-table-status bg-table-danger-status headerStatusDetailedPage">
                    {getHeaderData?.grnStatusHeader}
                  </span>
                ) : getHeaderData?.grnStatusHeader === "Posted" ? (
                  <span className="bg-table-status bg-table-info-status headerStatusDetailedPage">
                    {getHeaderData?.grnStatusHeader}
                  </span>
                ) : getHeaderData?.grnStatusHeader === "Invoice Created" ? (
                  <span className="bg-table-status bg-table-success-status headerStatusDetailedPage">
                    {getHeaderData?.grnStatusHeader}
                  </span>
                ) : getHeaderData?.grnStatusHeader === "Approve" ? (
                  <span className="bg-table-status bg-table-success-status headerStatusDetailedPage">
                    {getHeaderData?.grnStatusHeader}
                  </span>
                ) : getHeaderData?.grnStatusHeader === "Cancelled" ? (
                  <span className="bg-table-status bg-table-danger-status headerStatusDetailedPage">
                    {getHeaderData?.grnStatusHeader}
                  </span>
                ) : (
                  getHeaderData.grnStatusHeader
                )}
              </span>
            </h2>
            <p className="subText">Quality Information </p>
            <hr />
            <Row className="mb-4">
              <Col
                xs={12}
                md={{ span: 2, offset: 10 }}
                lg={{ span: 2, offset: 10 }}
                className="text-left"
              ></Col>
            </Row>
            <Row className="mb-4">
              {/* edit button */}
              {formInputs?.grnStatusHeader !== "Cancelled" && (
                <>
                  {editMode && (
                    <Col
                      xs={6}
                      md={{ span: 2, offset: 10 }}
                      lg={{ span: 2, offset: 10 }}
                      className="text-left"
                    >
                      <Col xs={6} md={2} lg={2} className="text-left">
                        <button className="btnInfo" onClick={TrasnportUpdate}>
                          Edit
                        </button>
                      </Col>
                      {/* )} */}
                    </Col>
                  )}
                  {!editMode && (
                    <Col
                      xs={6}
                      md={{ span: 2, offset: 8 }}
                      lg={{ span: 2, offset: 8 }}
                      className="text-left "
                      onClick={handleUpdate}
                    >
                      <button className="btnInfo">Update</button>
                    </Col>
                  )}
                  {!editMode && (
                    <Col xs={6} md={2} lg={2} className="text-left">
                      <button
                        className="btnInfo btn-danger"
                        onClick={cancelUpdate}
                      >
                        Cancel
                      </button>
                    </Col>
                  )}
                </>
              )}
            </Row>

            <Row className="mb-4">
              <Col xs={12} md={8} lg={8} className="text-right">
                {workflow?.workflow_record?.decision?.length > 0 &&
                  workflow?.workflow_record?.decision?.map((item, index) => (
                    <button
                      className={
                        item === "Approve" || item === "Submit"
                          ? "btnCommon btn-approve"
                          : "btnCommon btn-danger"
                      }
                      onClick={() => showApproveModal(item)}
                      key={index}
                    >
                      <i
                        className={
                          item === "Approve" || item === "Submit"
                            ? "bi bi-check2-circle"
                            : "bi bi-x-circle"
                        }
                      ></i>{" "}
                      {item}
                    </button>
                  ))}
              </Col>
            </Row>

            {/* grn details */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible1
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility1}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">ID</span>
                    </Col>
                    <Col xs={12} md={9} lg={9}>
                      <span className="headerTitle">Quality Details</span>
                      {/*  <span className="subHeaderTitle">
                        RFQ Header Information
                      </span> */}
                    </Col>

                    <Col xs={2} md={1} lg={1} className="">
                      <SourcingCommonFilter />
                    </Col>
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible1 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="GRN Number"
                          name="grnNr"
                          id="grnNr"
                          value={getHeaderData?.grnNr}
                          disabled={true}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="PO Number"
                          name="purchasingDocumentNr"
                          id="purchasingDocumentNr"
                          value={getHeaderData?.purchasingDocumentNr}
                          // //onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="PO Value (INR)"
                          name="purchasingDocumentValue"
                          id="purchasingDocumentValue"
                          value={getHeaderData?.purchasingDocumentValue}
                          //onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Delivered On"
                          name="createdAt"
                          id="createdAt"
                          value={formatDate(formInputs.createdAt)}
                          //onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Quality Check Created On"
                          name="createdAt"
                          id="createdAt"
                          value={formatDate(formInputs.createdAt)}
                          //onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Delivery/GRN Remarks"
                          name="grnRemark"
                          id="grnRemark"
                          value={formInputs.grnRemark}
                          disabled={editMode}
                          onChange={onInputChange}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Status "
                          name="grnStatus"
                          placeholder=""
                          value={formInputs.grnStatus}
                          //onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Goods Receiver"
                          name="generatedBy"
                          id="generatedBy"
                          value={formInputs.generatedBy}
                          //onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Quality Checker"
                          name="createdBy"
                          id="createdBy"
                          value={formInputs.createdBy}
                          //onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/* Line Items 2*/}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible2
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility2}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">QD</span>
                    </Col>
                    <Col xs={12} md={6} lg={7}>
                      <span className="headerTitle">Quality Details</span>
                      {/* <span className="subHeaderTitle">
                        Material/ Service Details
                      </span> */}
                    </Col>

                    <Col xs={2} md={1} lg={1} className="">
                      <SourcingCommonFilter />
                    </Col>
                  </Row>
                </h2>
                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible2 ? "visible" : ""
                  }`}

                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          // title=""
                          columns={columns}
                          // data={qualityCheckItems}
                          data={sortedQualityCheckItems}
                          progressPending={loading}
                          pagination
                          // paginationServer
                          // paginationTotalRows={totalRows}
                          // onChangeRowsPerPage={handlePerRowsChange}
                          // onChangePage={handlePageChange}
                          selectableRows
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                        />
                      </Col>
                      {showBarcodeModal && selectedBarcodeRow && (
                        <Modal
                          show={showBarcodeModal}
                          onHide={handleCloseBarcodeModal}
                          size="lg"
                        >
                          <Modal.Header closeButton>
                            <Modal.Title>Barcode Details</Modal.Title>
                          </Modal.Header>

                          <Modal.Body>
                            {/* LINE ITEM DETAILS */}
                            <div className="mb-3">
                              <p>
                                <strong>Material Code:</strong>{" "}
                                {selectedBarcodeRow.materialCode}
                              </p>
                              <p>
                                <strong>Description:</strong>{" "}
                                {selectedBarcodeRow.materialDescription}
                              </p>
                              <p>
                                <strong>GRN Item Nr:</strong>{" "}
                                {selectedBarcodeRow.grnItemNr}
                              </p>
                              <p>
                                <strong>PO Item:</strong>{" "}
                                {selectedBarcodeRow.purchasingDocumentItemNr}
                              </p>
                              <p>
                                <strong>Quantity:</strong>{" "}
                                {selectedBarcodeRow.grnQuantity}
                              </p>
                            </div>

                            <hr />

                            {/* BARCODE INFO TABLE */}
                            <table className="table table-bordered">
                              <thead>
                                <tr>
                                  <th>Barcode No</th>
                                  <th>Status</th>
                                  <th>Created On</th>
                                  <th>Godown</th>
                                </tr>
                              </thead>
                              <tbody>
                                {selectedBarcodeRow.barcodeInfo.map(
                                  (barcode, index) => (
                                    <tr key={index}>
                                      <td>{barcode.barcodeNr}</td>
                                      <td>{barcode.status}</td>
                                      <td>{barcode.createdOn}</td>
                                      <td>{barcode.godown}</td>
                                    </tr>
                                  ),
                                )}
                              </tbody>
                            </table>
                          </Modal.Body>

                          <Modal.Footer>
                            <button
                              className="btn btn-secondary"
                              onClick={handleCloseBarcodeModal}
                            >
                              Close
                            </button>
                          </Modal.Footer>
                        </Modal>
                      )}
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* GRN Attachments 3*/}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible3
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility3}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">GA</span>
                    </Col>
                    <Col xs={12} md={9} lg={9}>
                      <span className="headerTitle">GRN Attachments</span>
                      {/*  <span className="subHeaderTitle">
                        RFQ Header Information
                      </span> */}
                    </Col>

                    <Col xs={2} md={1} lg={1} className="">
                      <SourcingCommonFilter />
                    </Col>
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible3 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding  justify-content-center align-items-center"
                      >
                        <div className="d-flex flex-column ">
                          <p className="fw-medium m-0 text-nowrap">
                            Shipping Documents
                          </p>

                          {(formInputs?.shippingDocuments && (
                            <img
                              src="assets/img/newIcons/attached-file.png"
                              className="mt-1 attachmentIcon"
                              alt="attachments"
                              onClick={() =>
                                handleViewFile(formInputs?.shippingDocuments)
                              }
                            />
                          )) ||
                            "--"}
                        </div>
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding  justify-content-center align-items-center"
                      >
                        <div className="d-flex flex-column ">
                          <p className="fw-medium m-0 text-nowrap">
                            Other Attachments
                          </p>

                          {(formInputs?.otherAttachments && (
                            <img
                              src="assets/img/newIcons/attached-file.png"
                              className="mt-1 attachmentIcon"
                              alt="attachments"
                              onClick={() =>
                                handleViewFile(formInputs?.otherAttachments)
                              }
                            />
                          )) ||
                            "--"}
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      {/* Item Text  */}
      <CommonItemLevelDatatableModal
        show={getItemTextModalShow}
        onHide={() => itemTextHideModal()}
        columns={getItemHeaderTextColumns}
        data={getItemHeaderTextData}
        title={getItemHeaderTextModalTitle}
      />

      <ApproveRemarksModal
        show={modalShow}
        onHide={() => hideModal()}
        onvaluechange={handleValueChange}
      />

      {/* Success Modal Workflow */}
      <SuccessModal
        show={getShowSuccessModal}
        onHide={() => hideSuccessModal()}
        successmodaldata={getsucceModalData}
        nextnavigate={getNextNavigate}
      />
      <FileViewerModal
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
      />
      <QualityCheckModalDetail
        show={showQCModal}
        onHide={() => setShowQCModal(false)}
        qcType={qcType}
        rowData={selectedRow}
        editMode={editMode}
        onSaveQualityCheck={handleSaveQualityCheck}
      />
    </main>
  );
};

export default QualityCheckDetailsV5;
